import type fr from "./fr";

const en: typeof fr = {
  "tooltip.block.plot.display_settings": "Graph visualization settings",
  "tooltip.block.plot.link": "Synchronize the time navigation between charts",
  "tooltip.block.plot.zoom.reset":
    "Display the defined zooms in the chart settings. Synchronized charts will inherit the same temporal zoom.",
  "tooltip.editor.plot.add_data": "Add data",
  "tooltip.editor.plot.data_period_range":
    "Selection of data available in the graph, before any zoom",
  "tooltip.editor.plot.delete_encoding": "Delete",
  "tooltip.editor.plot.encoding_zoom": "Data range displayed by default, amongst loaded data range",
  "tooltip.editor.plot.group_axis_by_unit": "Data with the same unit will appear on a single axis",
  "tooltip.editor.plot.marker_info": "Choice of information conveyed by marker color and shape",
  "tooltip.editor.plot.move_down": "Move down",
  "tooltip.editor.plot.move_up": "Move up",
  "tooltip.editor.plot.temporal_sync":
    "Enable this option to synchronize the time period between charts. All charts will present the same period and navigating one chart will impact the data displayed in others.",
  "tooltip.editor.plot.thresholds": "Threshold settings",
};

export default en;
